export const Marquee = () => {
  const items = [
    "Multimarca",
    "Diagnosis OBD-II",
    "Distribución",
    "Embragues",
    "ITV",
    "Neumáticos",
    "Alineación 3D",
    "Híbridos",
    "Diésel",
    "Gasolina",
    "Preparación",
    "Frenos",
  ];
  return (
    <div
      data-testid="marquee-strip"
      className="border-y border-zinc-800/80 bg-zinc-950 py-5 overflow-hidden"
    >
      <div className="marquee">
        {[...items, ...items].map((it, i) => (
          <div key={i} className="flex items-center gap-10 px-7">
            <span className="font-heading text-2xl md:text-3xl font-semibold uppercase tracking-tight text-zinc-100">
              {it}
            </span>
            <span className="text-red-600 text-xl">◆</span>
          </div>
        ))}
      </div>
    </div>
  );
};
